import { useParams } from 'react-router-dom';

import { ScreenPlaceholder } from '@/components/ScreenPlaceholder';

export function CheckoutScreen() {
  const { plan } = useParams();
  return (
    <ScreenPlaceholder
      title={`Checkout — ${plan ?? 'select a plan'}`}
      phase="Phase 0 — Platform base"
      description="5 variants: Stripe Pro annual · Starter monthly · Export Pack once · Contra Pro annual · Contra Export Pack. Order summary + payment method + receipt."
    />
  );
}
